/* =========================================================================
   PMN · Modification d'un article du panier
   Le bouton « Modifier » du panier ouvre la fiche produit avec ?pmn_edit=<clé de ligne>.
   Ce script :
     1. retrouve la ligne dans /cart.js ;
     2. pré-remplit le formulaire (variante via ?variant=, propriétés, quantité) ;
     3. expose window.PMNCartEdit, que product-form.js utilise pour REMPLACER la ligne
        (ajout de la nouvelle version, suppression de l'ancienne, retour au panier).
   Les personnalisateurs spécifiques (packs…) écoutent « pmn:cart-edit:filled » pour
   resynchroniser leur interface.
   ========================================================================= */
(function () {
  const params = new URLSearchParams(window.location.search);
  const key = params.get('pmn_edit');
  if (!key) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const domReady = new Promise((resolve) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', resolve, { once: true });
    else resolve();
  });

  window.PMNCartEdit = { key, quantity: 1, ready: false };

  function mainForm() {
    return (
      document.querySelector('[id^="MainProduct-"] product-form form[id^="product-form-"]') ||
      document.querySelector('product-form form[id^="product-form-"]')
    );
  }

  /* Champs « properties[...] » du formulaire, y compris ceux rattachés via l'attribut form= */
  function propertyFields(form) {
    const formId = form.getAttribute('id');
    return Array.from(document.querySelectorAll('[name^="properties["]')).filter(
      (el) => el.form === form || el.getAttribute('form') === formId
    );
  }

  function propertyName(el) {
    return el.name.slice('properties['.length, -1).trim();
  }

  function fill(item) {
    const form = mainForm();
    if (!form) return;
    const props = {};
    Object.keys(item.properties || {}).forEach((k) => {
      if (item.properties[k] !== null && item.properties[k] !== undefined) props[k.trim()] = String(item.properties[k]);
    });

    const fields = propertyFields(form);
    const touched = [];

    /* La forme (fiches multiformes) d'abord : elle active / désactive la 2e ligne de texte */
    const shapeInput = document.getElementById('shapeInput');
    if (shapeInput && props[propertyName(shapeInput)]) {
      const value = props[propertyName(shapeInput)];
      const btn = Array.from(document.querySelectorAll('.shape-btn')).find((b) => b.dataset.value === value);
      if (btn) btn.click();
      else shapeInput.value = value;
    }

    /* 1er passage : on pose toutes les valeurs sans déclencher d'événement… */
    fields.forEach((el) => {
      if (el === shapeInput) return;
      const name = propertyName(el);
      if (!(name in props)) return;
      const value = props[name];
      if (el.type === 'radio') {
        el.checked = el.value === value;
        if (el.checked) touched.push(el);
      } else if (el.type === 'checkbox') {
        el.checked = el.value === value;
        touched.push(el);
      } else if (el.type !== 'file') {
        if (el.disabled && el.type !== 'hidden') el.disabled = false;
        el.value = value;
        touched.push(el);
      }
    });

    /* Quantité */
    const qty = form.querySelector('[name="quantity"]') || document.querySelector(`[name="quantity"][form="${form.getAttribute('id')}"]`);
    if (qty) {
      qty.value = item.quantity;
      touched.push(qty);
    }

    /* … 2e passage : les aperçus et compteurs se mettent à jour avec un état complet */
    touched.forEach((el) => {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.dispatchEvent(new CustomEvent('pmn:cart-edit:filled', { detail: { item, properties: props, form } }));
    showBanner(form);
    keepEditLabel(form);
    scrollToCustomisation(form);
  }

  /* Défilement animé jusqu'à la zone de personnalisation */
  function scrollToCustomisation(form) {
    const formId = form.getAttribute('id');
    const firstField = propertyFields(form).find((el) => el.type !== 'hidden' && el.offsetParent !== null);
    const target =
      document.querySelector('[data-pack-customizer]') ||
      document.querySelector('[data-shape-picker]') ||
      (firstField && (firstField.closest('.product__info-container > *') || firstField)) ||
      document.querySelector(`[form="${formId}"]`);
    if (!target) return;

    const header = document.querySelector('sticky-header');
    const headerOffset =
      header && ['always', 'reduce-logo-size'].includes(header.dataset.stickyType) ? header.getBoundingClientRect().height : 0;
    const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 24;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }

  /* « Valider la modification » à la place de « Ajouter au panier ».
     Plusieurs scripts réécrivent ce libellé (variante, champs remplis…) : on le maintient. */
  const EDIT_LABEL = 'Valider la modification';
  function keepEditLabel(form) {
    const button = form.querySelector('[type="submit"]');
    const label = button && button.querySelector('span');
    if (!label) return;
    const apply = () => {
      if (button.disabled || label.textContent.trim() === EDIT_LABEL) return;
      label.textContent = EDIT_LABEL;
    };
    new MutationObserver(apply).observe(label, { childList: true, characterData: true, subtree: true });
    apply();
  }

  function showBanner(form) {
    const anchor = form.closest('product-form') || form;
    if (!anchor || document.querySelector('.pmn-edit-banner')) return;
    const banner = document.createElement('div');
    banner.className = 'pmn-edit-banner';
    banner.setAttribute('role', 'status');
    banner.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>' +
      '<span><strong>Vous modifiez un article de votre panier.</strong> Validez pour remplacer l’article existant.</span>' +
      '<a href="' + (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '">Annuler</a>';
    anchor.parentNode.insertBefore(banner, anchor);

    const style = document.createElement('style');
    style.textContent =
      '.pmn-edit-banner{display:flex;align-items:center;gap:1rem;margin:0 0 1.2rem;padding:1rem 1.4rem;border:1px solid rgba(201,79,61,.3);border-radius:1.2rem;background:#fdf3ee;color:rgb(var(--color-foreground));font-size:1.3rem;line-height:1.4;}' +
      '.pmn-edit-banner svg{flex:0 0 1.8rem;width:1.8rem;height:1.8rem;color:#c94f3d;}' +
      '.pmn-edit-banner span{flex:1 1 auto;}' +
      '.pmn-edit-banner a{flex:0 0 auto;color:#c94f3d;font-weight:700;}';
    document.head.appendChild(style);
  }

  fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => {
      const item = (cart.items || []).find((i) => i.key === key);
      if (!item) {
        window.PMNCartEdit = null;
        return;
      }
      window.PMNCartEdit = { key, quantity: item.quantity, ready: true };
      return domReady.then(() => {
        /* Laisse les scripts de la fiche (aperçus, formes, options) s'initialiser avant de pré-remplir */
        setTimeout(() => fill(item), 300);
      });
    })
    .catch(() => {
      window.PMNCartEdit = null;
    });
})();
